var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "services-gall-slideshow" },
    [
      _c(
        "VueSlickCarousel",
        _vm._b({}, "VueSlickCarousel", _vm.settings, false),
        _vm._l(_vm.slides, function(slide) {
          return _c("article", { key: slide.id }, [
            _c("img", { attrs: { src: slide.image, alt: "" } }),
            _vm._v(" "),
            _c("h3", [_vm._v(_vm._s(slide.title))])
          ])
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }